export const DeliveryMethodsEndpoint = (makeRequest) => {
    return {
        // returns configuration data for the delivery methods with the given name
        // throws an error if the delivery method is not found
        fetchByName(params, options) {
            return makeRequest('GET', '/v1/deliver/delivery_methods/fetch_by_name', params, options);
        },
        // determines the delivery methods available given an address's state and address's zip code
        fetchByStateAndZip(params, options) {
            return makeRequest('GET', '/v1/deliver/delivery_methods/fetch_by_state_and_zip', params, options);
        },
        // determines the delivery methods applied to a list of shipments
        fetchByShipmentIDs(params, options) {
            return makeRequest('GET', '/v1/deliver/delivery_methods/fetch_by_shipment_ids', params, options);
        },
    };
};
//# sourceMappingURL=delivery_methods_endpoint.js.map